import Surveys from '../surveys/Surveys.vue';
import Notifications from '../notifications/Notifications.vue';

export default {
  data() {
    return {
      pagePers: null,
      dialogPers: false,
      formVisible: false,
    };
  },
  components: {
    Surveys,
    Notifications,
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    requirePers() {
      return this.$store.state.settings.profile_pers === true && !this.$store.state.user.pers_at;
    },
    account() {
      return this.$store.state.user.account;
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    hasSurvey() {
      return this.$store.state.surveys.hasSurvey;
    },
    hasNotifications() {
      return this.$store.state.notifications.hasNotifications;
    },
    isBannersOn() {
      return this.$store.state.settings.module_banners === true;
    },
    banners() {
      return this.$store.state.banners.bannersList || [];
    },
    taxes() {
      return this.$store.state.settings.taxes === true;
    },
  },
  methods: {
    ConfirmPers() {
      const app = this;
      app.$store.getters.axl.post('profiles/api/auth/confirm-pers', { profile_id: app.user.profile_id })
        .then(() => {
          app.user.pers_at = true;
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        });
    },
    LoadPers() {
      const app = this;
      app.$store.getters.ax.post('profiles/api/register/info')
        .then((response) => {
          app.pagePers = response.data.pagePers;
        });
    },
    receiveMessage(e) {
      try {
        if (e.origin !== 'https://forms.yandex.ru') {
          return;
        }
    
        if (typeof e.data === 'string' && e.data.includes('iframe-height')) {
          const data = JSON.parse(e.data);
          const height = data['iframe-height'];
    
          if (height && this.$refs.iframe) {
            this.$refs.iframe.style.height = `${height}px`;
          }
        }
      } catch (err) { err; }
    },
    toggleForm() {
      this.formVisible = !this.formVisible;

      if (!this.formVisible) {
        this.$nextTick(() => {
          if (this.$refs.iframe) {
            this.$refs.iframe.src = '';
          }
        });
      } else {
        this.$nextTick(() => {
          if (this.$refs.iframe) {
            this.$refs.iframe.style.height = '700px';
          }
        });
      }
    },
  },
  created() {
    this.user && this.$store.dispatch('surveys/GetSurveys', this.user.profile_id);
    this.user && this.$store.dispatch('notifications/GetNotifications', this.user.profile_id);
    this.isBannersOn && this.$store.dispatch('banners/GetBannersList');
  },
  mounted() {
    this.$store.dispatch('GetProfile');
    this.$store.dispatch('GetSettings');
    if (this.requirePers) {
      this.LoadPers();
    }
    window.addEventListener('message', this.receiveMessage, false);
  },
};
